import PropTypes from 'prop-types'
import React from 'react'
import Button from 'components/Button'
import Input from 'components/Form/Input'
import classes from './EditRoute.scss'

import { guid } from 'helpers/index'

export const submitInputId = `submit-${guid()}`

export const EditRoute = (props) => (
  <form onSubmit={props.handleSubmit} className={classes['form']}>
    <input type='submit' id={submitInputId} className={classes.hidden} />

    <header className={classes['header']}>
      <div className={classes['header-title']}>
        Editing Route
        <span className={classes['header-title--unimportant']}> – {props.route.id}</span>
      </div>

      <div className={classes['header-buttons']}>
        <Button submit options={['green', 'small', 'desktop']}>
          Update
        </Button>

        <Button confirm options={['red', 'small']} callback={() => props.handleDelete(props.route.id)}>
          Delete
        </Button>
      </div>
    </header>

    <fieldset>
      <Input label='Name' placeholder='name' {...props.fields.name} />
      <Input label='Region' placeholder='eg. North Bay' {...props.fields.region} />
    </fieldset>

    <footer className={classes['footer']}>
      <Button element={'label'} htmlFor={submitInputId} stick options={['green', 'block']}>
        Update Route
      </Button>
    </footer>
  </form>
)

EditRoute.propTypes = {
  route: PropTypes.object.isRequired,
  onSubmit: PropTypes.func, // actual submit function
  handleSubmit: PropTypes.func.isRequired, // redux-form function
  handleDelete: PropTypes.func.isRequired,
  fields: PropTypes.object.isRequired,
  submitting: PropTypes.bool.isRequired
}

export default EditRoute



// WEBPACK FOOTER //
// ./src/components/Routes/Edit/EditRoute.js